import { string, object, boolean } from 'yup';

import cms from '../../../data/cms.json';
import dayjs from 'dayjs';

export const validationSchemaDefault = (hasModelIssueDate: boolean) =>
    object({
        birthCountry: string().required(cms.validations.REQUIRED_FIELD).nullable(),
        idCardCountry: string().required(cms.validations.REQUIRED_FIELD).nullable(),
        issuer: string()
            .required(cms.validations.REQUIRED_FIELD)
            .min(2, 'Délka pole musí mít alespoň 2 znaky')
            .nullable(),
        citizenship: string().required(cms.validations.REQUIRED_FIELD).nullable(),
        validateSecondCitizenship: boolean(),
        secondCitizenship: string()
            .when('validateSecondCitizenship', {
                is: true,
                then: (schema) => schema.required(cms.validations.REQUIRED_FIELD).nullable(),
            })
            .nullable(),
        birthplace: string().required(cms.validations.REQUIRED_FIELD).nullable(),
        bankAccountNo: string().required(cms.validations.REQUIRED_FIELD).nullable(),
        bankAccountCode: string().required(cms.validations.REQUIRED_FIELD).nullable(),
        email: string().email(cms.validations.EMAIL_FIELD).required(cms.validations.REQUIRED_FIELD),
        phone: string().required(cms.validations.REQUIRED_FIELD),
        issueDate: hasModelIssueDate
            ? string().notRequired()
            : string()
                  .test('yearValidation', cms.validations.REQUIRED_VALID_DATE_FIELD, (_, meta) => {
                      const yearString = meta.originalValue.toString().split(' ')[3];

                      const bottomThreshold = 2000;

                      return !(Number(yearString) < bottomThreshold) && !(Number(yearString).toString().length < 4);
                  })
                  .test('issueDateOverlap', cms.validations.ISSUE_DATE_GT_TODAY, (value) => {
                      return !dayjs(value).isAfter(new Date());
                  }),
    });
